/**
 * Utility to convert quiz data structure to Assessment Question format
 * This allows Quiz component to reuse Assessment components
 */
import { Question } from '../types';

export function convertQuizDataToQuestions(quizData: any[]): Question[] {
  if (!quizData || !Array.isArray(quizData)) {
    return [];
  }

  return quizData.map((item, index) => {
    const questionType = Object.keys(item)[0];
    const questionData = item[questionType];

    // Map quiz question types to assessment question types
    let mappedQuestionType = questionType;
    if (questionType === 'multiple_choice_questions') {
      mappedQuestionType = 'multiple_choice_question';
    } else if (questionType === 'single_choice_questions') {
      mappedQuestionType = 'single_choice_question';
    } else if (questionType === 'true_or_false') {
      mappedQuestionType = 'true_or_false_question';
    }

    // Convert test_options to answers format
    const answers = questionData?.test_options?.map((opt: any) => 
      typeof opt === 'string' ? opt : opt?.option
    ) || [];

    // Build Question object matching Assessment format
    const question: Question = {
      metadata_uid: questionData?._metadata?.uid || `quiz-${index}`,
      question_type: mappedQuestionType,
    };

    // Add question data based on type
    if (mappedQuestionType === 'multiple_choice_question') {
      question.multiple_choice_question = {
        question: questionData?.question || '',
        answers,
      };
    } else if (mappedQuestionType === 'single_choice_question') {
      question.single_choice_question = {
        question: questionData?.question || '',
        answers,
      };
    } else if (mappedQuestionType === 'true_or_false_question') {
      question.true_or_false_question = {
        question: questionData?.question || '',
        answers: [true, false],
      };
    }

    return question;
  });
}

/**
 * Convert quiz answer format to QuizItem format
 */
export function convertQuizAnswerToQuizItem(
  questionUid: string,
  selectedOptions: any,
  questionIndex: number
) {
  return {
    question_uid: questionUid,
    selected_options: selectedOptions,
    qindex: questionIndex,
    isSubmitted: false,
  };
}
